import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faClone, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import React from "react";

import { Icon } from "src/base-components/Icon";
import { MotionDropdownPanel } from "src/base-components/MotionDropdownPanel";
import { DropdownItem } from "src/design-system/Dropdown";

type MenuItem = {
  icon: IconProp;
  key: string;
  label: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;

  onDeleteRow: () => void;
  onDuplicateRow: () => void;
  onCopyAsPayload?: () => void;

  resetSelection: () => void;
};

export const RowMenu: React.FC<Props> = ({
  isOpen,
  onClose,
  children,

  onDeleteRow,
  onDuplicateRow,
  onCopyAsPayload,
  resetSelection: onResetSelection,
}) => {
  const items: MenuItem[] = [
    // { key: "add-above", label: "Add a test case above" },
    // { key: "add-below", label: "Add a test case below" },
    { key: "duplicate", label: "Duplicate", icon: faClone },
    onCopyAsPayload && {
      key: "copy-as-payload",
      label: "Copy payload as JSON",
      icon: faClone,
    },
    { key: "delete", label: "Delete", icon: faTrashAlt },
  ].filter(Boolean) as MenuItem[];

  const onClick = async (key: string) => {
    if (key === "delete") {
      onDeleteRow();
      onResetSelection();
    }

    if (key === "duplicate") {
      onDuplicateRow();
      onResetSelection();
    }

    if (key === "copy-as-payload") {
      onCopyAsPayload?.();
    }

    onClose();
  };

  return (
    <Menu>
      <MenuButton>{children}</MenuButton>
      {isOpen && (
        <MenuItems
          anchor={{
            to: "bottom start",
            gap: 6,
            offset: -19,
          }}
          as={MotionDropdownPanel}
          className="overflow-y-auto"
          static
        >
          {items.map((item) => (
            <MenuItem
              key={item.key}
              as={DropdownItem}
              data-loc={`dataset-table-${item.label.toLowerCase()}-action`}
              onMouseDownCapture={() => onClick(item.key)}
            >
              <div className="flex items-center gap-x-2">
                <Icon color="text-gray-500" icon={item.icon} size="xs" />
                {item.label}
              </div>
            </MenuItem>
          ))}
        </MenuItems>
      )}
    </Menu>
  );
};
